import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './CategorySidebar.css';
import { API_BASE_URL } from '../../config/api';

const CategorySidebar = ({ onCategorySelect }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [categories, setCategories] = useState([]);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const selectedCategoryId = searchParams.get('category');

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/categories`);
        if (response.ok) {
          const data = await response.json();
          console.log('Categories API response:', data);
          const categoriesArray = Array.isArray(data) ? data : (data.value || data.categories || []);
          setCategories(categoriesArray);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => {
    if (onCategorySelect) {
      onCategorySelect(category);
    }
    navigate(`/products?category=${category.id}`);
  };

  const handleSubcategoryClick = (category, subcategory) => {
    navigate(`/products?category=${category.id}&subcategory=${subcategory.slug}`);
  };

  return (
    <div className="category-sidebar" onMouseLeave={() => setHoveredCategory(null)}>
      <div className="category-list">
        {categories.slice(0, 10).map((category) => (
          <div key={category.id}>
            <div 
              className={`category-item ${selectedCategoryId === String(category.id) ? 'active' : ''} ${hoveredCategory?.id === category.id ? 'hovered' : ''}`}
              onClick={() => handleCategoryClick(category)}
              onMouseEnter={() => setHoveredCategory(category)}
            >
              <span className="category-name">{category.name}</span>
              {category.subcategories && category.subcategories.length > 0 && (
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 20 20" 
                  fill="none"
                >
                  <path 
                    d="M8 14.5L12 10.5L8 6.5" 
                    stroke={hoveredCategory?.id === category.id || selectedCategoryId === String(category.id) ? "#333333" : "#6D6D6D"} 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          </div>
        ))}
      </div>
      <span className="see-more" onClick={() => navigate('/all-categories')}>See more</span>

      {/* Flyout subcategory panel - appears to the right */}
      {hoveredCategory && hoveredCategory.subcategories && hoveredCategory.subcategories.length > 0 && (
        <div 
          className="subcategory-flyout"
          onMouseEnter={() => setHoveredCategory(hoveredCategory)}
          onMouseLeave={() => setHoveredCategory(null)}
        >
          <div className="subcategory-flyout-header">{hoveredCategory.name}</div>
          <div className="subcategory-flyout-list">
            {hoveredCategory.subcategories.map((sub) => (
              <div 
                key={sub.id} 
                className="subcategory-flyout-item"
                onClick={() => handleSubcategoryClick(hoveredCategory, sub)}
              >
                <span>{sub.name}</span>
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                  <path d="M8 14.5L12 10.5L8 6.5" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategorySidebar;
